document.addEventListener('DOMContentLoaded', () => {
  console.log('[BUNDLE VALIDATOR] Script initialized.');

  // Enforces that if any component of a mixed kit is removed, has its quantity increased, 
  // or a standalone duplicate variant from the same kit is in the cart, the discount is cleared.
  function validateCartBundles(cartData) {
    console.log('[BUNDLE VALIDATOR] validateCartBundles called with:', cartData);
    if (!cartData || !cartData.items) {
      console.log('[BUNDLE VALIDATOR] No items or invalid cartData.');
      return;
    }

    const bundles = {};
    const bundleVariantIds = new Set();
    let hasQtyIncreasedBundleItem = false;
    
    // Group cart items by bundle ID, track expected counts, and collect variant IDs
    cartData.items.forEach(item => {
      if (item.properties && item.properties._bundle_id) {
        const bid = item.properties._bundle_id;
        const expected = parseInt(item.properties._bundle_expected_count) || 0;
        
        if (!bundles[bid]) {
          bundles[bid] = {
            actualCount: 0,
            expectedCount: expected,
            items: []
          };
        }
        bundles[bid].actualCount += 1;
        bundles[bid].items.push(item);

        // Track the variant ID of the bundle items
        bundleVariantIds.add(item.variant_id);

        // Check if quantity of the bundle item is increased (> 1)
        if (item.quantity > 1) {
          hasQtyIncreasedBundleItem = true;
          console.warn(`[BUNDLE VALIDATOR] Bundle item quantity increased for variant ${item.variant_id}: ${item.quantity}`);
        }
      }
    });

    console.log('[BUNDLE VALIDATOR] Grouped bundles:', bundles);
    console.log('[BUNDLE VALIDATOR] Bundle variant IDs:', [...bundleVariantIds]);
    
    let hasIncompleteBundle = false;
    
    // 1. Check if any bundle count is less than expected
    for (const [bid, data] of Object.entries(bundles)) {
      if (data.actualCount < data.expectedCount) {
        hasIncompleteBundle = true;
        console.warn(`[BUNDLE VALIDATOR] Incomplete bundle ${bid} detected: ${data.actualCount} of ${data.expectedCount} panels.`);
      }
    }

    // 2. Check if a bundle item's quantity is increased
    if (hasQtyIncreasedBundleItem) {
      hasIncompleteBundle = true;
    }

    // 3. Check if any standalone item (no bundle ID) matches a variant ID of the bundle items
    const hasStandaloneDuplicate = cartData.items.some(item => {
      const isStandalone = !item.properties || !item.properties._bundle_id;
      return isStandalone && bundleVariantIds.has(item.variant_id);
    });

    if (hasStandaloneDuplicate) {
      hasIncompleteBundle = true;
      console.warn('[BUNDLE VALIDATOR] Standalone duplicate of a bundle component detected in cart.');
    }

    let hasAppliedDiscount = false;
    try {
      hasAppliedDiscount = sessionStorage.getItem('sds_bundle_discount_applied') === 'true';
    } catch(e) {}

    if (!hasAppliedDiscount) {
      hasAppliedDiscount = cartData.items.some(item => 
        (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) ||
        (item.discounts && item.discounts.length > 0) ||
        (item.total_discount && item.total_discount > 0)
      ) || (cartData.cart_level_discount_applications && cartData.cart_level_discount_applications.length > 0) ||
           (cartData.total_discount && cartData.total_discount > 0);
    }

    console.log('[BUNDLE VALIDATOR] Status:', { hasIncompleteBundle, hasAppliedDiscount });

    // If an incomplete/invalid bundle state is found, clear checkout discount code and reload
    if (hasIncompleteBundle && hasAppliedDiscount && !window.isClearingDiscount) {
      console.log('[BUNDLE VALIDATOR] Clearing checkout discount code...');
      window.isClearingDiscount = true;
      try {
        sessionStorage.setItem('sds_bundle_discount_applied', 'false');
      } catch(e) {}
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: '' })
      })
        .then(res => res.json())
        .then(() => {
          console.log('[BUNDLE VALIDATOR] Shopify checkout discount cleared successfully. Reloading page...');
          window.location.reload();
        })
        .catch(err => {
          console.error('[BUNDLE VALIDATOR] Error clearing discount:', err);
          window.isClearingDiscount = false;
        });
    }
  }

  // ─── Method 1: Intercept global window.fetch to detect incomplete bundles ────
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      let url = args[0];
      // Resolve url if Request object is passed
      if (url && typeof url === 'object' && url.url) {
        url = url.url;
      }
      if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add'))) {
        if (window.isClearingDiscount) {
          console.log('[BUNDLE VALIDATOR] Fetch interceptor bypassed: clearing discount in progress.');
          return response;
        }
        response.clone().json().then(cartData => {
          console.log('[BUNDLE VALIDATOR] Fetch Interceptor caught cart change:', url);
          validateCartBundles(cartData);
        }).catch(e => console.error('[BUNDLE VALIDATOR] Fetch Interceptor JSON parse error:', e));
      }
      return response;
    });
  };

  // ─── Method 2: Intercept AJAX XMLHttpRequest calls ───────────────────────────
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', () => {
      if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add'))) {
        if (window.isClearingDiscount) {
          console.log('[BUNDLE VALIDATOR] XHR interceptor bypassed: clearing discount in progress.');
          return;
        }
        try {
          const cartData = JSON.parse(this.responseText);
          console.log('[BUNDLE VALIDATOR] XHR Interceptor caught cart change:', url);
          validateCartBundles(cartData);
        } catch(e) {
          console.error('[BUNDLE VALIDATOR] XHR Interceptor JSON parse error:', e);
        }
      }
    });
    return originalOpen.apply(this, arguments);
  };

  // ─── Method 3: Subscribe to Dawn's pubsub cart updates as fallback ───────────
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('[BUNDLE VALIDATOR] PubSub cartUpdate event received.');
      if (event && event.cartData) {
        validateCartBundles(event.cartData);
      }
    });
  }

  // ─── Run validation immediately on page load ──────────────────────────────────
  fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      console.log('[BUNDLE VALIDATOR] Initial load validation:', cartData);
      validateCartBundles(cartData);
    })
    .catch(err => console.error('[BUNDLE VALIDATOR] Error during initial cart load validation:', err));
});
